module.exports = __webpack_public_path__ + "static/cukolada-photo-6be47753b8c34210bb9e68fd67f379bb.jpg";